import { getFirestore, doc, getDoc } from "firebase/firestore";
import app from "./firebase.config";

const db = getFirestore(app);

// Campus class to structure the data
class Campus {
  constructor(domain, signupCount, name, threshold) {
    this.domain = domain;
    this.signupCount = signupCount;
    this.name = name;
    this.threshold = threshold;
  }
}

// Function to fetch and filter campuses from Firestore
export async function fetchCampuses() {
  try {
    // Get the campusList document
    const campusListDoc = doc(db, "campusList", "campusList");
    const docSnap = await getDoc(campusListDoc);
    
    if (!docSnap.exists()) {
      throw new Error("Campus list document not found in Firestore");
    }
    
    const campusData = docSnap.data();
    const campuses = [];
    
    // Iterate through all keys (hashed campus IDs)
    // eslint-disable-next-line no-unused-vars
    for (const [campusId, campus] of Object.entries(campusData)) {
      // Skip if showOnWebsite is false
      if (!campus.showOnWebsite) {
        continue;
      }
      
      // Check if required fields exist for campuses with showOnWebsite = true
      if (!campus.name || !campus.threshold) {
        console.warn(`Warning: Campus with domain ${campus.domain || 'unknown'} has showOnWebsite=true but is missing required fields (name or threshold). Skipping.`);
        continue;
      }
      
      // Create Campus object and add to array
      const campusObj = new Campus(
        campus.domain,
        campus.signupCount || 0, // Default to 0 if not present
        campus.name,
        campus.threshold
      );
      
      campuses.push(campusObj);
    }
    
    // Sort campuses by signupCount (descending) for better display
    campuses.sort((a, b) => b.signupCount - a.signupCount);
    
    return campuses;
    
  } catch (error) {
    // Re-throw the error for the calling code to handle
    throw new Error(`Failed to fetch campuses: ${error.message}`);
  }
}

// Optional: Export the Campus class if you need it elsewhere
export { Campus };